import { useEffect } from 'react';
import Status from '../Status/Status';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Game.scss";
import Logo from '../Logo/Logo';
import Table from '../Table/Table';
import Players from '../Players/Players';
import { useAppSelector } from '../../hooks/redux';
import {
  gameActions,
} from './gameSlice';
import store, { RootState } from '../../store/store';
import Lobby from '../Lobby/Lobby';
import Hand from '../Hand/Hand';
import Sentence from '../Sentence/Sentence';
import GameVote from './GameVote';
import GameResults from './GameResults';
import { useParams } from 'react-router-dom';
import { LocalStorageKeys } from '../../models/LocalStorageKeys';
import { GameStatus } from '../../models/GameStatus';
import { diceActions } from '../Dice/diceSlice';
import LobbySettings from '../Lobby/LobbySettings';

function Game() {
  const gameState = useAppSelector((state: RootState) => state.game);
  const { gameId, secondParam } = useParams();
  const localToken = localStorage.getItem(LocalStorageKeys.TOKEN_KEY);
  const navigate = useNavigate();

  useEffect(() => {

    if (!localToken) {
      // create new user and immediately join
      // to be able to login via game link
      navigate(`/new/${gameId}`, { replace: true });
      return;
    }

    if (secondParam) {
      // legacy urls /<token>/<game-id>
      navigate(`/${gameId}`, { replace: true });
      return;
    }

    // set game id for dice slice so that it never receives wrong values
    store.dispatch(diceActions.setGameId({
      gameId: gameId,
    }))

    store.dispatch(gameActions.join({
      token: localToken,
      gameId: gameId,
    }));

  }, [gameState.isConnected]);

  useEffect(() => {
    if (gameState.status && gameState.status === GameStatus.WRONG_GAME_ID) {
      store.dispatch(gameActions.startConnecting());
      navigate(`/matchmaking`, { replace: true });
    }
  }, [gameState.isConnected, gameState.status, navigate]);

  let gameContent = <Logo />;

  if (gameState.gameId && gameState.gameId === gameId && !gameState.gameStarted && gameState.isConnected) {
    gameContent = <Lobby />
  }

  if (gameState.gameStarted) {
    gameContent = <>
      <Players />
      <Table />
      <Sentence />
      <Hand />
    </>
  }

  if (gameState.gameFinished && !gameState.gameVoteFinished) {
    gameContent = <>
      <GameVote />
    </>
  }

  if (gameState.gameVoteFinished) {
    gameContent = <>
      <GameResults />
    </>
  }

  if (!gameState.isConnected && !gameState.gameStarted) {
    gameContent = <>
      <Logo />
    </>
  }

  if (gameState.status === GameStatus.LOBBY_SETTINGS) {
    gameContent = <LobbySettings />
  }

  // to prevent right click
  /* onContextMenu={(e) => e.preventDefault()} */

  return (<>
    <Status />
    <div className="game-container">
      {gameContent}
    </div>
  </>);
}

export default Game;
